//import cookie from "../../store/modules/cookies"

export default function auth({next, store}) {
  //console.log(cookie.get("token"))
  /* if (cookie.get("token")) {
    //console.log("We have found a token", cookie.get("token"));
    store.dispatch("userauth/aTokenLogin", cookie.get("token"))
  } */
  
  
  if ((!store.getters["userauth/gLoggedIn"]) ) {
    //clear the local storage
    next({ name: "Login" });
  } else {
    store.dispatch("userauth/aValidToken")
  }
  
  return next();
}